export const SUBTIER_MENU_ACTIONS = {CREATE:'Create',EDIT:'Edit',DELETE:'Delete',LINK:'Link',UPDATE:'Update',SAVE:'Save',CANCEL:'Cancel'};
export const GRAL_NAVIGATION = {BACK:'Back'};
export const GRAL_VALIDATION_MSGS = {
    "required_field": "This field is required",
    "delete_validation": "Are you sure that you want to delete this record?",
    "error_while_saving": "An error occurs while saving, please try again.",
    "error_while_deleting": "An error occurs while deleting, please try again.",
    "succesfully": "Information saved successfully",
    "subtier_link": "Error while creating subtier relationship (already exists)",
    "survey_link": "Error while creating survey relationship (already exists)",
}

export const GRAL_ALERT_SEVERITIES = {
    success: "Success",
    error: "Error",
    info: "Info"
}
export const SUBTIER_ADMIN_TITLE = "Subtier Administration";

export const SUBTIER_SOURCE_SYSTEM = "SURVEY";

export const QUESTION_TYPES = {
    NUM: "NUM",
    SELECT: "SELECT",
    CHEK_POPUP: "CHEK_POPUP",
    TITL_POPUP: "TITL_POPUP",
    OPEN: "OPEN",
    CHECK: "CHECK",
    SEL_CNTRY: "SEL_CNTRY",
    SEL_CTY_UW: "SEL_CTY_UW",
    SEL_STATE: "SEL_STATE",
    FILE: "FILE",
    MULT_CNTRY: "MULT_CNTRY",
    MULTI_SEL: "MULTI_SEL",
};
  
export const POPUP_QUESTIONS_TITLES = [QUESTION_TYPES.TITL_POPUP, QUESTION_TYPES.CHEK_POPUP];

export const CRS_EXT_TOKEN = "crsExtToken";
export const CRS_EXT_PARAM = "crsExtParam";

export const CRS_EXT_TOKEN_RENEWAL_INTERVAL = 50 * 60 * 1000; //Value in milliseconds (50 minutes) for token renewal interval
export const CRS_EXT_TOKEN_RENEWAL_INTERVAL_ON_ERROR = 1 * 60 * 1000; //Value in milliseconds (1 minute) for token renewal interval